import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import {
  SwapSupervisorModalComponent
} from '../../shared/components/modal/modal-views/swap-supervisor-modal/swap-supervisor-modal.component';
import { IModalData, ModalService } from '../../shared/components/modal/modal.service';
import { IServiceRegistration } from '../../shared/model/service-registration.model';
import { ISupervisor } from '../../shared/model/supervisor.model';
import { updateServiceRegistrationWithSupervisor } from "../store/service-registrations/service-registrations.actions";

export enum OppConfigRecordType {
  regReq = 'Registration Request Records',
  activeVolunteer = 'Active Volunteer Records'
}

@Injectable({providedIn: 'root'})
export class SwapSupervisorService {

  constructor(
    private modalService: ModalService,
    private store: Store) { }

  public openSwapSupervisorModal(
    id: string,
    activeServices: IServiceRegistration[],
    availableSupervisors: ISupervisor[],
    recordType: OppConfigRecordType
  ): Observable<ISupervisor> {
    const selectedService = this.getServiceRegistrationFromId(id, activeServices);
    const supervisorsToShow = availableSupervisors.filter(supervisor => supervisor.id !== selectedService.supervisorId);
    const data: IModalData = {
      currentSupervisorId: selectedService.supervisorId,
      supervisors: supervisorsToShow
    };

    const result$ = new Subject<ISupervisor>();
    const modalRef = this.modalService.open(SwapSupervisorModalComponent, data)!;

    modalRef.componentInstance.swapSupervisorEvent.subscribe((supervisor: ISupervisor) => {
      this.updateServiceRegistrationWithSwappedSupervisor(supervisor, selectedService, recordType);
      modalRef.close();
      result$.next(supervisor);
      result$.complete();
    });

    return result$.asObservable();
  }

  public updateServiceRegistrationWithSwappedSupervisor(supervisor: ISupervisor, selectedService: IServiceRegistration, recordType: OppConfigRecordType) {
    let serviceToUpdate = {
      ...selectedService,
      supervisorId: supervisor.id
    };

    this.store.dispatch(updateServiceRegistrationWithSupervisor({
      registration: serviceToUpdate,
      supervisor,
      recordType
    }));
  }

  public getServiceRegistrationFromId(id: string, services: IServiceRegistration[]) {
    return services.find(service => service.id === id)!;
  }

  public getSupervisorName(id: string, availableSupervisors: ISupervisor[]) {
    const foundSupervisor: ISupervisor | undefined =
      availableSupervisors.find((supervisor: ISupervisor): boolean => supervisor.id === id);

    return foundSupervisor ? `${foundSupervisor.firstName} ${foundSupervisor.lastName}` : 'No supervisor found';
  }

}
